import React from 'react'
import Img from "gatsby-image"
import { useJsonForm } from 'gatsby-tinacms-json'
import { usePlugin } from 'tinacms'

import Layout from '../components/Layout'
import Banner from '../components/Banner'
import { convertTimestamp } from '../components/Helpers'
import { InlineForm, InlineTextarea } from 'react-tinacms-inline'
import SEO from '../components/Seo'

const Press = ({ data }) => {

    const formConfig = {
        id: 3,
        label: 'Edit Contact Page',
        fields: [
            {
                label: 'SEO Title',
                name: 'rawJson.seo_title',
                component: 'textarea'
            },
            {
                label: 'Meta Description',
                name: 'rawJson.meta_description',
                component: 'textarea'
            }
        ]
    }

    const [modifiedData, form] = useJsonForm(data.page, formConfig)
    usePlugin(form)

    return (
        <>
            <SEO
                title={modifiedData.seoTitle}
                description={modifiedData.metaDescription}
            />
            <Layout>
                <InlineForm form={form} >
                    <div className="mainContainer">
                        <div className="container-fluid s2">
                            <div className="container">
                                <h1>
                                    <InlineTextarea name="rawJson.title" />
                                </h1>
                                <h2>
                                    <InlineTextarea name="rawJson.subtitle" />
                                </h2>
                                {data.posts.edges.filter(({ node }) => {
                                    return !(process.env.NODE_ENV === 'production' && !node.published)
                                }).map(({ node }, i) => {
                                    return (
                                        <div key={i} className="row comments">
                                            
                                            <div className="col-md-4 profile">
                                                {node.image &&
                                                    <Img fluid={node.image.childImageSharp.fluid} alt={node.imageAlt} />
                                                }
                                                <p>{node.author}<br /><span>San Diego, CA | {convertTimestamp(node.createdAt)}</span></p>
                                            </div>
                                            {!node.published &&
                                                <div className="is-draft">DRAFT</div>
                                            }
                                            <div className="col-md-8 contento">
                                                <h3>{node.title}</h3>
                                                <p>{node.excerpt}</p>
                                                <p>
                                                    <a className="btn btn-default" href={`/press/${node.slug}/`} role="button">Read Full Press Release</a>
                                                </p>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </InlineForm>
                <Banner />
            </Layout>
        </>
    )
}

export default Press

export const pageQuery = graphql`
query {
    page: pagesJson(fileRelativePath: { eq: "/content/pages/press.json" }) {
        metaDescription: meta_description
        seoTitle: seo_title
        title
        subtitle

        rawJson
        fileRelativePath
    }

    posts: allPostsJson(sort: {fields: created_at, order: DESC}) {
        edges {
            node{
                title
                body
                image {
                    relativePath
                    childImageSharp {
                        fluid(maxWidth: 1200) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                imageAlt: image_alt
                createdAt: created_at
                published
                seoTitle: seo_title
                metaDescription: meta_description
                slug
                excerpt
                author

                rawJson
                fileRelativePath
            }
        }
    }
}`